<template>
  <div>
    <el-form ref="dataForm" :model="dataForm" :rules="dataRule" label-width="126px" class="readOnlyStyle">
      <!-- 申请人信息填写 -->
      <div class="pt10">
        <p class="messageTitle">{{ $t("creation.messageTitle") }}</p>
        <div class="pt36">
          <el-form-item :label="$t('creation.applicant')" prop="applicantName" ref="applicantName">
            <el-input v-model="dataForm.applicantName" disabled :placeholder="$t('common.placeholder.enter')" class="wd500"></el-input>
          </el-form-item>
          <el-form-item :label="$t('creation.mobile')" prop="applicantPhone" ref="applicantPhone">
            <prefix-phone v-model="dataForm.applicantPhone" disabled class="wd500"></prefix-phone>
          </el-form-item>
          <el-form-item :label="$t('creation.email')" prop="applicantEmail" ref="applicantEmail">
            <el-input v-model="dataForm.applicantEmail" disabled :placeholder="$t('common.placeholder.enter')" class="wd500"></el-input>
          </el-form-item>
          <el-form-item :label="$t('creation.residentialAddress')" prop="residentialAddress" ref="residentialAddress">
            <el-input v-model="dataForm.residentialAddress" disabled :placeholder="$t('common.placeholder.enter')" class="wd500"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" plain size="small" icon="el-icon-edit" @click="goEdit">{{ $t("common.button.edit") }}</el-button>
          </el-form-item>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import { validateLocation } from "@/utils/common";
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      dataForm: {
        applicantName: "",
        applicantPhone: "",
        applicantEmail: "",
        residentialAddress: "",
      },
      dataRule: {
        applicantName: [
          {
            required: true,
            message: this.$t("common.placeholder.toEdit"),
            trigger: "submit",
          },
        ],
        applicantPhone: [
          {
            required: true,
            message: this.$t("common.placeholder.toEdit"),
            trigger: "submit",
          },
        ],
        applicantEmail: [
          {
            required: true,
            message: this.$t("common.placeholder.toEdit"),
            trigger: "submit",
          },
          {
            type: "email",
            message: this.$t("common.regular.email"),
            trigger: "submit",
          },
        ],
        residentialAddress: [
          {
            required: true,
            message: this.$t("common.placeholder.toEdit"),
            trigger: "submit",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("user", ["userInfo"]),
  },
  methods: {
    ...mapActions("user", ["fetchUserInfo"]),
    // 获取个人资料
    getPersonal() {
      this.fetchUserInfo()
        .then(res => {
          const { nickname, phone, email, address } = {
            ...this.userInfo,
          };
          this.dataForm = {
            applicantName: nickname,
            applicantPhone: phone,
            applicantEmail: email,
            residentialAddress: address,
          };
        })
        .catch(err => {});
    },
    // 去编辑
    goEdit() {
      this.$router.push("/account");
    },
    // 提交表单(由父级触发)
    dataFormSubmit() {
      return new Promise((resolve, reject) => {
        this.$refs["dataForm"].validate((valid, object) => {
          if (valid) {
            resolve({
              ...this.dataForm,
            });
          } else {
            validateLocation(object, this);
            reject();
          }
        });
      });
    },
  },
  created() {
    // 获取个人资料
    this.getPersonal();
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-form-item__label {
    height: 38px;
    line-height: 16px;
    display: flex;
    align-items: center;
    text-align: left;
    /* word-break: break-all; */
  }
}

.messageTitle {
  font-size: 16px;
  line-height: 1em;
  font-weight: 600;
}
</style>
